import React, { useCallback, useContext, useEffect } from 'react'
import ModalContext from 'contexts/ModalContext'
import SocieteNotificationModal from './SocieteNotificationModal'
import { useScreenSizeUp } from 'hooks/useScreenSize'

interface Props {
  activeSocieteNotification: App.BusinessTraveller.SocieteNotificationType | null
}

function SocieteNotificationModalTrigger({ activeSocieteNotification }: Props) {
  const isDesktop = useScreenSizeUp('tablet')
  const showModal = useContext(ModalContext)

  const triggerModal = useCallback(() => {
    if (!activeSocieteNotification) return
    showModal(<SocieteNotificationModal notificationType={activeSocieteNotification} />)
  }, [showModal, activeSocieteNotification])

  useEffect(() => {
    if (!activeSocieteNotification) return
    // COMPLETION always shows in modal regardless of screen size
    // Other notification types only show on modal when it is mobile view
    if (activeSocieteNotification !== 'COMPLETION' && isDesktop) return
    triggerModal()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSocieteNotification, isDesktop])

  return null
}

export default SocieteNotificationModalTrigger
